import { useQuery } from '@tanstack/react-query';
import { apiClient, ClientSummary } from '@/api/client';

export function useClients() {
  return useQuery({
    queryKey: ['clients'],
    queryFn: async () => {
      const response = await apiClient.clients.list();
      return response.clients;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - client list rarely changes
  });
}

export function useClientConfig(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'config'],
    queryFn: () => apiClient.clients.getConfig(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
